import { render, staticRenderFns } from "./sales_fw.vue?vue&type=template&id=6b0e4201&scoped=true"
import script from "./sales_fw.vue?vue&type=script&lang=js"
export * from "./sales_fw.vue?vue&type=script&lang=js"
import style0 from "./sales_fw.vue?vue&type=style&index=0&id=6b0e4201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e4201",
  null
  
)

export default component.exports